// Mock data for the Current Action Review screen.
// Scenario: Sarah reports a leaking Gut X bottle; the prepared reply and
// CS ticket are ready for Jamie Dorsey to confirm. Mirrors the approved
// HTML copy exactly.
export const CURRENT_ACTION_MOCK = {
  priorityHeading: 'Help Sarah with a damaged bottle',
  priorityEyebrow: 'Highest priority right now',
  what: 'Resolve a delivery issue',
  whyNow: 'Sarah just reported a leaking bottle in her delivered order.',
  nextAction: 'Confirm the prepared CS ticket and reassure Sarah.',
  nextActionDetail: 'CS owns resolution after the confirmed handoff.',
  inboundMessage: 'My Gut X arrived, but one bottle is leaking. Can you help?',
  inboundTime: '10:26 AM',
  preparedReply:
    "Hi Sarah, I'm sorry one bottle arrived leaking. Let me get our Customer Service team the details.",
  callNotes:
    'Sarah reports one Gut X bottle arrived leaking. Related order EX-1042. No resolution promised.',
  ticketIssue:
    'Sarah reports that one Gut X bottle arrived leaking. Please review the damaged item and confirm the appropriate resolution.',
  ticketIdExample: 'EX-CS-1043',
  horseName: 'Duke',
  horseBreedDisciplineAge: 'Quarter Horse · 9 years · Reining',
  horseProduct: 'Gut X',
  horseRoutine: 'Grain twice daily; free-choice hay',
  horseGoal: 'Maintain condition during travel',
  orderId: 'EX-1042',
  orderStatus: 'Delivered',
  orderSubscriptionLabel: 'Subscription',
  orderSubscriptionState: 'Active',
};
